// client/src/coms/views/watch_together_parts/watchTogetherConstants.js
export const PROVIDERS = [
  { key: 'youtube', label: 'YouTube', enabled: true },
  { key: 'spotify', label: 'Spotify', enabled: true },
  { key: 'misc', label: 'Misc', enabled: true },
  { key: 'twitch', label: 'Twitch', enabled: false },
];

export const YT_PLAYER_STATE_UNSTARTED = -1;
export const YT_PLAYER_STATE_ENDED = 0;
export const YT_PLAYER_STATE_PLAYING = 1;
export const YT_PLAYER_STATE_PAUSED = 2;
export const YT_PLAYER_STATE_BUFFERING = 3;
export const YT_PLAYER_STATE_CUED = 5;

export const END_THRESHOLD_SECONDS = 0.45;
export const END_STALL_WINDOW_MS = 1400;
export const INFO_POLL_MS = 300;
export const LOCAL_RESYNC_ON_PLAY_DELAY_MS = 220;
